import React from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmDialog from './ConfirmDialog';
import OkCancelConfirmDialogProps from './OkCancelConfirmDialogProps';

const OkCancelConfirmDialog: React.FC<React.PropsWithChildren<OkCancelConfirmDialogProps>> = (props) => {
  const { t } = useTranslation();
  const {
    title, content, data, okText, cancelText, onOk, onCancel, open,
  } = props;

  return (
    <ConfirmDialog
      content={content}
      open={open}
      title={title}
      data={data}
      leftButton={{
        label: cancelText ?? t('generic.cancel'),
        onClick: onCancel,
      }}
      rightButton={{
        label: okText ?? t('generic.ok'),
        onClick: onOk,
      }}
    />
  );
};

export default OkCancelConfirmDialog;
